/* ==========================================================================
   Search
   ========================================================================== */

declare const my_ajax_object: any;

document.addEventListener('DOMContentLoaded', function () {
	const search = document.querySelector('.search') as HTMLElement;
	const searchIcon = document.querySelector('.btn--search') as HTMLElement;
	const closeIcon = document.querySelector('.icon-close') as HTMLElement;
	const searchFormInput = document.querySelector('form.search-form [name=s]') as HTMLInputElement;
	const searchForm = document.querySelector('form.search-form') as HTMLFormElement;

	searchIcon.addEventListener('click', function (e) {
		e.preventDefault();
		search.classList.add('active');
		document.body.style.overflow = 'hidden';
		document.body.classList.add('search-open');

		setTimeout(function () {
			searchFormInput.focus();
		}, 300);
	});

	document.addEventListener('click', function (e) {
		if (e.target === closeIcon || closeIcon.contains(e.target as Node)) {
			search.classList.remove('active');
			document.body.style.overflow = '';
			document.body.classList.remove('search-open');
		}
	});

	// SEARCH AJAX FUNCTION
	let searchBounce: ReturnType<typeof setTimeout> | null = null;
	document.addEventListener('keyup', function (e) {
		if (e.target === searchFormInput) {
			if (searchBounce) {
				clearTimeout(searchBounce);
			}
			searchBounce = setTimeout(() => {
				searchForm.dispatchEvent(new Event('submit'));
			}, 250);
		}
	});

	let searchAjax: XMLHttpRequest | null = null;
	let lastQuery = '';
	searchForm.addEventListener('submit', function (e) {
		e.preventDefault();

		const s = searchFormInput.value;

		if (lastQuery === s) {
			return false;
		}
		lastQuery = s;

		if (searchAjax) {
			searchAjax.abort();
		}

		if (s) {
			updateSearchState('loading');
		} else {
			updateSearchState('default');
			return false;
		}

		searchAjax = new XMLHttpRequest();
		searchAjax.open('POST', my_ajax_object.ajax_url, true);
		searchAjax.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		const lang = /\/en(?:\/|$)/i.test(window.location.pathname)
			? 'en'
			: /\/es(?:\/|$)/i.test(window.location.pathname)
				? 'es'
				: 'pt';
		searchAjax.send('action=search_ajax&s=' + encodeURIComponent(s) + '&lang=' + lang);
		searchAjax.onload = function () {
			if (this.status === 200) {
				if (this.response) {
					const searchResults = document.querySelector('.search .results');
					if (searchResults) {
						searchResults.innerHTML = this.response;
						updateSearchState('results-ok');
					}
				} else {
					updateSearchState('no-results');
				}
			}
		};
	});
});

function updateSearchState(state: string) {
	const loadingElement = document.querySelector('.search .loading') as HTMLElement | null;
	const noContentElement = document.querySelector('.search .no-content') as HTMLElement | null;
	const defaultElement = document.querySelector('.search .default') as HTMLElement | null;

	switch (state) {
		case 'loading':
			if (loadingElement) {
				loadingElement.style.display = 'block';
			}
			if (noContentElement) {
				noContentElement.style.display = 'none';
			}
			if (defaultElement) {
				defaultElement.style.display = 'none';
			}
			break;
		case 'results-ok':
			if (loadingElement) {
				loadingElement.style.display = 'none';
			}
			break;
		case 'no-more-results':
			break;
		case 'no-results':
			if (loadingElement) {
				loadingElement.style.display = 'none';
			}
			if (noContentElement) {
				noContentElement.style.display = 'block';
			}
			break;
		case 'default':
		default:
			if (noContentElement) {
				noContentElement.style.display = 'none';
			}
			if (loadingElement) {
				loadingElement.style.display = 'none';
			}
			if (defaultElement) {
				defaultElement.style.display = 'block';
			}
			break;
	}
}
